module.exports = "<div id=\"e-mail-sender\">\n    <mat-progress-spinner *ngIf=\"sendEmailStatus == MailingStatusType.SENDING\"\n                          mode=\"indeterminate\" [diameter]=\"spinnerSize\">\n    </mat-progress-spinner>\n    <i id=\"e-mail-status-icon\" *ngIf=\"isSendingComplete()\"\n       [ngClass]=\"[iconClassByStatus(), emailSendStatusStyle()]\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/modules/customers/shared/components/emails/email.send.template.html
// module id = 1533
// module chunks = 0